module.exports = __webpack_public_path__ + "static/you-avatar-07144d6f891c82ab313ad7e9af2c51e1.svg";